import { SVGProps, Ref, forwardRef } from 'react'
const SvgEstatePlan = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.32 22.767 12 18.343l-6.32 4.424a.75.75 0 0 1-1.18-.614V2.593a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 1.5 1.5v19.56a.75.75 0 0 1-1.18.614v0ZM9 1.094v19.349M15 1.094v19.349"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgEstatePlan)
export default ForwardRef
